<template>
  <div class="user-dashboard-container">
    <SideBar class="sidebar" />

    <div class="dashboard-content">
      <div class="mainlist-content">
        <SearchBar @update:search="handleSearch" />

        <div class="title-container">
          <div class="today-title">Your Plan Here!</div>
          <SwitchIcon
            @calendarClick="goToCalendarPage"
            :activeButton="'list'"
          />
        </div>

        <!-- 监听 openNewTaskModal 事件并调用方法显示模态框 -->
        <BaseList
          :tasks="tasks"
          @openNewTaskModal="handleOpenNewTaskModal"
          :search-query="searchQuery"
          @openTaskModal="handleOpenTaskModal"
        />
        <!-- BasicModal 的显示控制通过 v-if 或 v-show -->
        <BasicModal
          v-if="isModalVisible"
          :isDetailMode="isDetailMode"
          :task="selectedTask"
          :categories="categories"
          @closeModal="isModalVisible = false"
          @newTaskCreated="handleNewTask"
          @updateTaskTiming="handleUpdateTaskTiming"
          @task-ended="handleTaskEnded"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SideBar from "@/components/global/SideBar.vue";
import SearchBar from "@/components/global/SearchBar.vue";
import BaseList from "@/components/global/BaseList.vue";
import SwitchIcon from "@/components/plan/SwitchIcon.vue";
import { useRouter } from "vue-router";
import BasicModal from "@/components/global/BasicModal.vue"; // 确保已导入
import { v4 as uuidv4 } from "uuid";
import { mapGetters } from "vuex";

export default {
  components: {
    SideBar,
    SearchBar,
    BaseList,
    SwitchIcon,
    BasicModal,
  },
  data() {
    return {
      isModalVisible: false, // 控制模态框显示的状态
      searchQuery: "", // 用于搜索查询的字符串
      selectedTask: null, // 存储当前选中的任务
      isDetailMode: false, // 控制模态框是显示任务详情还是添加新任务的模式
      selectedCategory: "", // 假设这是用户在 Modal 中选中的类别
    };
  },
  methods: {
    handleOpenNewTaskModal() {
      this.isModalVisible = true; // 显示模态框
      this.isDetailMode = false; // 确保模态框以编辑模式打开
      this.selectedTask = {}; // 清除选中的任务，确保模态框不会显示现有任务的详情
    },
    handleNewTask(newTaskDetails) {
      console.log("Received new task details in PlanList:", newTaskDetails); // Debugging

      // 首先声明和初始化newTask变量
      const newTask = {
        ...newTaskDetails,
        id: uuidv4(),
      };

      // 接下来是使用newTask变量的逻辑
      console.log("New task created:", newTask);

      // 假设类别数据需要更新，这里是一个示例，你需要根据实际逻辑调整
      const updatedCategories = this.categories.map((category) => {
        if (category.name === this.selectedCategory) {
          // 更新类别逻辑，例如增加计数或更新其他属性
        }
        return category;
      });

      // 提交新任务到 Vuex
      this.$store.dispatch("addNewTask", newTaskDetails);
      // 提交更新到 Vuex
      this.$store.commit("updateCategories", updatedCategories);

      this.isModalVisible = false; // 关闭 Modal
    },
    handleSearch(query) {
      this.searchQuery = query; // 更新BaseList组件的searchQuery数据属性
    },
    handleOpenTaskModal(task) {
      console.log("Opening task modal with task:", task); // 这里会打印出task对象

      this.selectedTask = task; // 假设你有一个selectedTask来存储当前选中的任务
      this.isModalVisible = true; // 控制BasicModal的显示
      this.isDetailMode = true; // 添加时设置为详情模式
    },
    handleUpdateTaskTiming(data) {
      // 打印收到的数据
      console.log("Received updateTaskTiming with data:", data);
      // 找到要更新的任务
      const taskIndex = this.tasks.findIndex((task) => task.id === data.id);
      if (taskIndex !== -1) {
        // 更新任务数据
        this.tasks[taskIndex].punchInTime = data.punchInTime;
        this.tasks[taskIndex].punchOutTime = data.punchOutTime;
        this.tasks[taskIndex].workingHours = data.workingHours;
        this.tasks = [...this.tasks];
      }
    },
    handleTaskEnded(task) {
      console.log("Received task-ended event in PlanList:", task);
    },
  },

  setup() {
    const router = useRouter();
    const goToCalendarPage = () => {
      router.push("/calendar");
    };

    return { goToCalendarPage };
  },
  created() {
    if (this.$route.query.newTask) {
      this.handleOpenNewTaskModal();
    }
  },
  computed: {
    ...mapGetters(["categories"]),
    ...mapGetters(["tasks"]),

    tasks() {
      return this.$store.getters.tasks;
    },
  },
  mounted() {
    console.log(this.categories); // 现在可以访问类别数据了
  },
};
</script>

<style>
body {
  min-height: 100vh !important;
}
.dashboard-content {
  flex-grow: 1;
  max-width: calc(100% - 250px); /* 限制最大宽度并减去侧边栏宽度 */
  margin-right: 30px; /* 设置右侧间距 */
}

.mainlist-content {
  padding: 70px 100px;
}

.title-container {
  display: flex;
  align-items: center;
  justify-content: space-between; /* 两端对齐 */
  margin-bottom: 20px;
  margin-top: 50px;
}
</style>
